import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'filterByFieldLength' })
export class filterByFieldLength implements PipeTransform {

  constructor(
  ) {
  }

  transform(items: any[] | null, config:{fields:string[], length:any, maxLength:number}):any[] {
    if (!items){
      return [];
    }
    if (config.length >= config.maxLength){
      return items.filter((elm)=>{
        let isAvailable = true;
        config.fields.forEach((field)=>{
          if(elm[field] && elm[field].toString().trim().length > 0){
            isAvailable = false;
            return false;
          }
        });
        return isAvailable;
      });
    }
    return items;
  }
}
